/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Query_CanceledInputs */

const en_error_query_canceled = /** @type {(inputs: Error_Query_CanceledInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The request took too long. Try again.`)
};

/**
* | output |
* | --- |
* | "The request took too long. Try again." |
*
* @param {Error_Query_CanceledInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_query_canceled = /** @type {((inputs?: Error_Query_CanceledInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Query_CanceledInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_query_canceled(inputs)
});